/**
 * Uses the above constant to convert front-end data into format back-end can use for validation
 *
 * @method credFrontToBack
 * @param {Object} frontEndValue Data to convert
 * @param {Object} frontEndRecaptcha Captcha response
 * @returns {Object}
 */
export const credFrontToBack = (frontEndValue, frontEndRecaptcha) => ({
    pin: frontEndValue.pin,
    referenceNumber: frontEndValue.referenceNumber,
    captchaResponse: frontEndRecaptcha || ""
});
/**
 * Uses the above constant to convert back-end data into format front-end can use for validation
 *
 * @method confirmBackToFront
 * @param {Object} backEndData Data to convert
 * @returns {Object}
 */
export const confirmBackToFront = (backEndData) => {
    const { name, ...rest } = backEndData;
    return {
        ...rest,
        decedent: name
    };
};
/**
 * Uses the above constant to convert front-end data into format back-end can use
 *
 * @method confirmValidationFrontToBack
 * @param {Object} frontEndData Data to convert
 * @param {String} authId Authorized Id
 * @returns {Object}
 */
export const confirmValidationFrontToBack = (frontEndData, authId) => ({
    firstName: frontEndData.firstName,
    lastName: frontEndData.lastName,
    referenceNumber: typeof frontEndData.referenceNumber === "number"
        ? frontEndData.referenceNumber
        : parseInt(frontEndData.referenceNumber, 10),
    pin: typeof frontEndData.pin === "number" ? frontEndData.pin : parseInt(frontEndData.pin, 10),
    attestation: frontEndData.authorized,
    emailAddress: frontEndData.email,
    decedentRelationship: frontEndData.relationship,
    authorizedId: authId === -1 ? null : authId,
    confirmation: frontEndData.validation ? formatValidationData(frontEndData.validation) : []
});
/**
 * Uses the above constant to convert front-end data into format back-end can use
 *
 * @method formatValidationData
 * @param {Object} validation Data to convert
 * @returns {Object}
 */
export const formatValidationData = (validation) => {
    const ids = Object.keys(validation);
    return ids.map(key => ({
        id: parseInt(key, 10),
        value: validation[key]
    }));
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/validation/dataConversion.ts